<ng-container *ngIf="loading">
  <fa-icon [icon]="spinnerIcon" animation="spin"></fa-icon>
  <div *ngIf="displayText && text">{{ text }}</div>
</ng-container>
